// extracted by mini-css-extract-plugin
module.exports = {"el":"PortfolioBody-module--el--1Hhmk","body":"PortfolioBody-module--body--2E9j5"};